import React, { useContext, useState } from "react"
import useEventActions from "../hooks/useEventActions"
import { AuthContext, LanguageContext } from "../context"
import { renderDateTime } from "../utils"
import { messagePassengers } from '../services/messaging'
import MessageModal from './MessageModal'

const EventVehicleRow = ({ vehicle, index, onEdit, onJoin, event, disabled }) => {

  const { authUser, userData } = useContext(AuthContext)
  const { t } = useContext(LanguageContext)

  const { isVehiclePassenger, myVehiclePassengers, isVehicleDriver } = useEventActions({ event })

  const [showDetails, setShowDetails] = useState(false)
  const [showMessageModal, setShowMessageModal] = useState(false)

  const handleToggleDetails = () => {
    setShowDetails((prev) => !prev)
  }

  const emptySeatsCount = (journeyType) => {
    if (!vehicle[journeyType]?.available) return 0
    if (!vehicle[journeyType]?.available_seats) return 0
    const vehicleSeats = vehicle[journeyType]?.available_seats || 0
    const vehicleTripPassengers = vehicle.passengers.filter(p => p[journeyType]) || []
    return vehicleSeats - vehicleTripPassengers.length
  }

  const fullSeatsCount = (journeyType) => {
    if (!vehicle[journeyType]?.available) return 0
    if (!vehicle[journeyType]?.available_seats) return 0
    const vehicleTripPassengers = vehicle.passengers.filter(p => p[journeyType]) || []
    return vehicleTripPassengers.length
  }

  const handleEdit = (e) => {
    e.preventDefault()
    onEdit(vehicle, index)
  }

  const handleJoin = () => {
    onJoin()
  }

  const passengersLabel = (journeyType) => {
    const passengers = myVehiclePassengers(index, journeyType)
    if (passengers.length === 0) return ''
    return passengers.map(p => p.firstname + (p.firstname === userData?.firstname ? ` (${t('generic.you')})` : '')).join(", ")
  }

  const promptMessagePassengers = async () => {
    console.log("promptMessagePassengers")
    setShowMessageModal(true)
  }

  const handleSendMessage = async (message) => {
    console.log("handleSendMessage", message)
    return await messagePassengers(event.id, index, message)
  }

  const formatPhoneNumber = (phone) => {
    if (!phone) return '';
    return phone.startsWith('+') ? phone : `+${phone}`;
  }

  return (
    <div className="">
      <div className="event-box px-6 py-4">
        <div className="flex flex-wrap items-center mb-4">
          <img src="/car-green.svg" alt="bus-icon" className="max-w-11 lg:max-w-16" />
          <span className="value ml-2">{vehicle.driver_firstname} </span>
          {authUser && authUser.uid === vehicle.driver_id && <button className="no-bg !px-2" onClick={handleEdit}>
            <img src="/edit.svg" />
          </button>}

          {authUser && <button className="ml-auto blue micro " onClick={handleToggleDetails}>
            <img src="/visibility.svg" />
            {showDetails ? t('vehicle.hide_detail') : t('vehicle.show_detail')}
          </button>}
        </div>
        {(showDetails && authUser) &&
          <div className="flex flex-wrap gap-3 info-box-mobile mb-4">
            <span className="name">{`${vehicle.driver_firstname} ${vehicle.driver_lastname}`}</span>
            <span className="inline-flex gap-2 break-all">
              <img src="/mail.svg" />
              {`${vehicle.email || ''}${vehicle.driver_id === authUser?.uid ? ` (${t('generic.you')})` : ''}`}</span>
            <span className="inline-flex gap-2 break-all">
              <img src="/smartphone.svg" />
              {formatPhoneNumber(vehicle.phone) || ''}</span>
          </div>
        }
        <div className="flex gap-6 justify-between flex-col md:flex-row">
          <div className="md:w-1/2">
            {vehicle.trip1.available && <>
              <div className="info-box-mobile">
                <div className="flex mb-4 text-left">
                  <span className="label !leading-4 w-24">{t('generic.appointment_outbound')}</span>
                  <span className="value !leading-4">{renderDateTime(vehicle.trip1.date)} </span>
                </div>
                <div className="flex mb-4 text-left">
                  <span className="label !leading-4 w-24">{t('generic.meeting_place')}</span>
                  <div >
                    <span className="value !leading-4">{vehicle.trip1.zip}, {`${vehicle.trip1.city}`}</span>
                    {(authUser && showDetails && vehicle.trip1.available) && <div className="flex flex-col label !leading-4">
                      <span className="">{`${vehicle.trip1.street} ${vehicle.trip1.number}`}</span>
                    </div>}
                  </div>
                </div>
                <div className="flex mb-4 text-left">
                  <span className="label !leading-4 w-24">{t('generic.places')}</span>
                  <div className="value !leading-4">
                    ({emptySeatsCount("trip1")}) {t('generic.places_available')}
                  </div>
                </div>
                {vehicle?.passengers?.filter(p => p.trip1)?.length > 0 && (
                  <div className="flex mb-4 text-left">
                    <span className="label !leading-4 w-24"> {t('vehicle.passagers')}</span>
                    <div className="mb-1 value !leading-4 gap-2 flex flex-col">
                      {vehicle.passengers.filter(p => p.trip1).map((p) =>
                        <div>
                          <span className="block">{`${p.firstname} `}</span>
                          {(authUser && showDetails) && <span className="block">{`${formatPhoneNumber(p.phone)}`}</span>}
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {vehicle.trip1.available && (emptySeatsCount("trip1") > 0 || isVehiclePassenger(index, 'trip1')) &&
                  <button className="blue small mt-auto w-full" onClick={handleJoin} disabled={disabled || !isVehiclePassenger(index, 'trip1') && emptySeatsCount("trip1") === 0}>
                    <img src="/group-add.svg" />
                    {isVehiclePassenger(index, 'trip1') ? t('generic.modify') : t('vehicle.join_button')}
                  </button>}
              </div>
            </>}
          </div>
          <div className="md:w-1/2">
            {vehicle.trip2.available && <>
              <div className="info-box-mobile">
                <div className="flex mb-4 text-left">
                  <span className="label !leading-4 w-24">{t('generic.appointment_back')}</span>
                  <span className="value !leading-4">{renderDateTime(vehicle.trip2.date)}</span>
                </div>
                <div className="flex mb-4 text-left">
                  <span className="label !leading-4 w-24">{t('generic.meeting_place')}</span>
                  <div>
                    <span className="value !leading-4">{vehicle.trip2.zip}, {`${vehicle.trip2.city}`}</span>
                    {(authUser && showDetails && vehicle.trip2.available) && <div className="flex flex-col label">
                      <span className="">{`${vehicle.trip2.street} ${vehicle.trip2.number}`}</span>
                    </div>}
                  </div>
                </div>
                <div className="flex mb-4 text-left">
                  <span className="label !leading-4 w-24">{t('generic.places')}</span>
                  <div className="value !leading-4">
                    ({emptySeatsCount("trip2")}) {t('generic.places_available')}
                  </div>
                </div>
                {vehicle?.passengers?.filter(p => p.trip2)?.length > 0 && (
                  <div className="flex mb-4 text-left">
                    <span className="label !leading-4 w-24"> {t('vehicle.passagers')}</span>
                    <div className="mb-1 value !leading-4 gap-2 flex flex-col">
                      {vehicle.passengers.filter(p => p.trip2).map((p) =>
                        <div>
                          <span className="block">{`${p.firstname} `}</span>
                          {(authUser && showDetails) && <span className="block">{`${formatPhoneNumber(p.phone)}`}</span>}
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {vehicle.trip2.available && (emptySeatsCount("trip2") > 0 || isVehiclePassenger(index, 'trip2')) &&
                  <button className="blue small mt-auto w-full" onClick={handleJoin} disabled={disabled || !isVehiclePassenger(index, 'trip2') && emptySeatsCount("trip2") === 0}>
                    <img src="/group-add.svg" />
                    {isVehiclePassenger(index, 'trip2') ? t('generic.modify') : t('vehicle.join_button')}
                  </button>}
              </div>
            </>}
          </div>

        </div>
        {(showDetails && vehicle?.notes) && <div className="flex flex-col w-full info-box !py-3 px-3 mt-6">
          <span className="">{vehicle?.notes}</span>
        </div>}

        {(showDetails && isVehicleDriver(vehicle) && vehicle?.passengers?.length > 0) && (
          <div className='mt-5 mb-4'>
            <button className='small light whitespace-normal w-full' onClick={promptMessagePassengers}>
              {t('vehicle.message_passengers')}
            </button>
          </div>
        )}

      </div>
      <MessageModal
        showModal={showMessageModal}
        onClose={() => setShowMessageModal(false)}
        title={t('vehicle.message_passengers')}
        onSend={handleSendMessage}
      />
    </div >
  )
}

export default EventVehicleRow